import React, { useEffect, useState } from 'react';
import { FaTwitter } from 'react-icons/fa';
import {
    ApprovaledlListLayout,
    ApprovaledlListBody,
    ApprovaledlListRow,
    ApprovaledlListRowKu,
    ApprovaledlListRowOfHead,
    ButtonContainer
} from './ApprovaledList.style.js';
import FW from '../../config/word.json';
import { RED } from '../../styles/color';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layouts/Main/MainLayout.index.js';
import {
    LoadingSpinner,
    LoadingOverlay,
    SmallButtonForReject,
    SmallButtonForDetail,
    colorButtonStyle
} from '../../styles/common.js';
import {
    getAllProInfoByAuthFlg,
    updateUserFromApproval
} from "../../api/project";
import Modal from 'react-modal';

// ⬇️ xlsx と file-saver をインポート
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function ApprovaledlList(props) {
    const threespace = '　　　';
    const onespace = '　';
    const navigate = useNavigate();

    const [tasks, setTasks] = useState([]);
    const [modalIsOpenForReject, setModalIsOpenForReject] = useState(false);
    const [currentTask, setCurrentTask] = useState({});
    const [reloadEffect, setReloadEffect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedUserFlg] = useState({});

    const [filterUserFlg, setFilterUserFlg] = useState('');
    const [filterTwitterName, setFilterTwitterName] = useState('');
    const [filterEmail, setFilterEmail] = useState('');


    const handleDetailClick = (item) => {
        navigate(`/register?userId=${item.user_id}`); // 適切なIDやパラメータを渡す
    };

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (!userId) {
            navigate('/');
        }
        getAllProInfoByAuthFlg('1').then(res => {
            setTasks(res.data);
        }).catch(err => {
            console.error(err);
        });
    }, [reloadEffect, navigate]);

    const handleApproveForReject = async () => {
        closeModalForReject();
        setLoading(true);
        await updateTaskForReject(currentTask);
        setLoading(false);
        resetState();
    };

    const updateTaskForReject = async (task) => {
        const jUser = {
            userId: task.user_id,
            email: task.email,
            userName: task.user_name,
            userFlg: selectedUserFlg[task.user_id],
            authFlg: '3'
        };
        try {
            const res = await updateUserFromApproval(jUser);
            if (res.code === 200) {
                navigate('/ApprovalList');
            }
        } catch (err) {
            console.error(err);
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
    };

    const openModalForReject = (task) => {
        setCurrentTask(task);
        setModalIsOpenForReject(true);
    };

    const closeModalForReject = () => {
        setModalIsOpenForReject(false);
    };

    const resetState = () => {
        setCurrentTask({});
        setReloadEffect(prev => !prev);
    };

    const TwitterIcon = () => <FaTwitter />;

    // 🔍 フィルター後の配列
    const filteredTasks = tasks.filter(item => {
        const matchUserFlg = filterUserFlg === '' || item.user_flg === filterUserFlg;
        const matchTwitter = filterTwitterName === '' || (item.twitter_name || '').toLowerCase().includes(filterTwitterName.toLowerCase());
        const matchEmail = filterEmail === '' || (item.email || '').toLowerCase().includes(filterEmail.toLowerCase());
        return matchUserFlg && matchTwitter && matchEmail;
    });

    // ⬇️ Excel出力処理
    const handleExportToExcel = () => {
        const worksheetData = filteredTasks.map(item => ({
            Twitter名: item.twitter_name,
            ユーザーID: item.user_id,
            表示名: item.user_name,
            メールアドレス: item.email,
            種別:
                item.user_flg === "1" ? "プロ" :
                item.user_flg === "2" ? "ゲスト" :
                item.user_flg === "3" ? "雀荘" :
                item.user_flg === "4" ? "麻雀BAR" : ""
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '承認済ユーザ一覧');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, '承認済ユーザ一覧.xlsx');
    };

    return (
        <MainLayout>
            <ApprovaledlListLayout>
                <ApprovaledlListBody>
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#008000'}}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        {FW.F_W_HOME_ApprovaledList}
                        </span>
                    </div>
                    {/* 絞り込み条件 */}
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            絞り込み条件
                        </span>
                    </div>

                    {/* 🔍 フィルターUI */}
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div>
                            <label>種別：</label>
                            <select value={filterUserFlg} onChange={(e) => setFilterUserFlg(e.target.value)}>
                                <option value=''>すべて</option>
                                <option value='1'>プロ</option>
                                <option value='2'>ゲスト</option>
                                <option value='3'>雀荘</option>
                                <option value='4'>麻雀BAR</option>
                            </select>
                        </div>
                        <div>
                            <label><TwitterIcon />：</label>
                            <input
                                type="text"
                                value={filterTwitterName}
                                onChange={(e) => setFilterTwitterName(e.target.value)}
                                placeholder="例: 麻雀太郎"
                            />
                        </div>
                        <div>
                            <label>E-Mail：</label>
                            <input
                                type="text"
                                value={filterEmail}
                                onChange={(e) => setFilterEmail(e.target.value)}
                                placeholder="例: example@mail.com"
                            />
                        </div>
                        <div>
                            <button onClick={() => {
                                setFilterUserFlg('');
                                setFilterTwitterName('');
                                setFilterEmail('');
                            }}>クリア</button>
                        </div>
                        <div>
                            {/* Excel出力ボタン */}
                            <button onClick={handleExportToExcel}>Excel出力</button>
                        </div>
                    </div>

                    {/* 承認済一覧の件数表示 */}
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            承認済一覧    📊 全データ：{tasks.length} 件 ／ フィルター結果：{filteredTasks.length} 件
                        </span>
                    </div>

                    {/* ヘッダー */}
                    <ApprovaledlListRowOfHead>Twitter名前／ID</ApprovaledlListRowOfHead>
                    <ApprovaledlListRowOfHead>{threespace}雀活マスター表示名前</ApprovaledlListRowOfHead>
                    <ApprovaledlListRowOfHead>{threespace}{threespace}E-Mail</ApprovaledlListRowOfHead>
                    <ApprovaledlListRowOfHead>{threespace}{threespace}プロ／ゲスト</ApprovaledlListRowOfHead>

                    {loading && (
                        <LoadingOverlay>
                            <LoadingSpinner />
                        </LoadingOverlay>
                    )}

                    {/* フィルター後の一覧 */}
                    {filteredTasks.map(item => (
                        <ApprovaledlListBody key={item.user_id}>
                            <ApprovaledlListRow>
                                <TwitterIcon />{item.twitter_name}／
                                <a href={`https://x.com/${item.user_id}`} target="_blank" rel="noopener noreferrer">{item.user_id}</a>
                            </ApprovaledlListRow>
                            <ApprovaledlListRow>{threespace}{item.user_name}</ApprovaledlListRow>
                            <ApprovaledlListRow>{threespace}{threespace}{item.email}</ApprovaledlListRow>
                            <ApprovaledlListRow>
                                {onespace}
                                <input type="radio" name={`userFlg_${item.user_id}`} value="1" checked={item.user_flg === '1'} readOnly />プロ
                                {onespace}
                                <input type="radio" name={`userFlg_${item.user_id}`} value="2" checked={item.user_flg === '2'} readOnly />ゲスト
                                {onespace}
                                <input type="radio" name={`userFlg_${item.user_id}`} value="3" checked={item.user_flg === '3'} readOnly />雀荘
                                {onespace}
                                <input type="radio" name={`userFlg_${item.user_id}`} value="4" checked={item.user_flg === '4'} readOnly />麻雀BAR
                                <SmallButtonForReject onClick={() => openModalForReject(item)}>解除</SmallButtonForReject>
                                <SmallButtonForDetail onClick={() => handleDetailClick(item)}>詳細</SmallButtonForDetail>
                            </ApprovaledlListRow>
                            <ApprovaledlListRowKu />
                        </ApprovaledlListBody>
                    ))}
                </ApprovaledlListBody>
            </ApprovaledlListLayout>

            {/* モーダル */}
            <Modal
                isOpen={modalIsOpenForReject}
                onRequestClose={closeModalForReject}
                contentLabel="雀活マスター否認"
            >
                <div>
                    <p>
                        ◾️申込者：<br />
                        ・{currentTask.twitter_name}<br />
                        ・{currentTask.user_name}<br />
                        ・{currentTask.email}<br />
                        ・{currentTask.user_flg === "1" ? "プロ" :
                            currentTask.user_flg === "2" ? "ゲスト" :
                            currentTask.user_flg === "3" ? "雀荘" :
                            currentTask.user_flg === "4" ? "麻雀BAR" : ""}
                        <br /><br />
                        利用権限を解除した後、すでに連携済のスケジュール、お気に入りデータを削除します。<br /><br />
                        雀活マスターアプリの利用権限を解除しますか？
                    </p>
                </div>
                <ButtonContainer>
                    <button onClick={closeModalForReject}>いいえ</button>
                    <button style={colorButtonStyle(RED)} onClick={handleApproveForReject}>解除</button>
                </ButtonContainer>
            </Modal>
        </MainLayout>
    );
}

export default ApprovaledlList;
